export default "__VITE_ASSET__ClMo$N$t__"